import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./sass/main.scss";
import App from "./Routes/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Redux/store/Store";
import { persistor } from "./Redux/store/Store";
import { PersistGate } from "redux-persist/integration/react";

// import { render } from "react-dom";
// import { createRoot } from "react-dom/client";

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
